{
  "title": "Search",
  "input_label": "Search products, orders, customers, consignors or pages",
  "placeholder": "Card name, cert number, product code, order number, customer…",
  "searching": "Searching…",
  "close": "Close search",
  "results": "Results",
  "source_error": "could not search here — try again",
  "nothing": "Nothing found for “{{term}}”",
  "nothing_hint": "Check the spelling, or scan the card's certificate / product code.",
  "empty_hint": "Type a card name, a certificate or order number — or scan a barcode.",
  "keys_hint": "↑ ↓ to move · Enter to open · Esc to close · ? shows the shortcuts",
  "opens_new_tab": "opens in a new tab",
  "actions": {
    "add_card": "Add a card",
    "to_ship": "Orders to ship",
    "open_pos": "Open the register",
    "edit_home": "Edit the home page",
    "edit_menus": "Edit the website menus",
    "translate_missing": "Translate the empty texts",
    "translate_missing_count_one": "Translate the empty texts ({{count}})",
    "translate_missing_count_other": "Translate the empty texts ({{count}})"
  },
  "groups": {
    "lookup": "Exact match",
    "actions": "Do something",
    "products": "Products",
    "orders": "Orders",
    "customers": "Customers",
    "consignors": "Consignors",
    "pages": "Pages of the admin",
    "recent_opened": "Opened recently",
    "recent_queries": "Searched recently"
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "open_search": "Search",
    "new_product": "Add a card (on the products pages)",
    "go_orders": "Go to orders",
    "go_products": "Go to products",
    "show_shortcuts": "Show this list",
    "note": "Shortcuts do not work while you type in a box or while Japanese input is choosing characters."
  }
}
